import { OLButton } from "OLButton";
import { Link } from "react-router-dom";
import { useStyles } from "./Subheader.styles";

interface Props {
  text?: string;
  link: string;
  icon?: React.ReactElement | null;
  variant?: "contained" | "outlined";
  disabled?: boolean;
  iconOnly?: boolean;
  size?: "small" | "medium" | "large";
  "data-test-id"?: string;
  prevPath?: string;
}

export const SubheaderLinkButton = ({
  text,
  link,
  icon,
  variant = "contained",
  disabled,
  iconOnly,
  size = "medium",
  "data-test-id": dataTestId = "",
  prevPath,
}: Props) => {
  const classes = useStyles();

  return (
    <Link to={link} state={{ prevPath: prevPath }}>
      <OLButton
        startIcon={icon ? <span className={classes.icon}>{icon}</span> : null}
        variant={variant}
        disabled={disabled}
        size={size}
        className={`${disabled ? classes.disabledLinkButton : ""}  ${iconOnly ? classes.iconOnly : ""}`}
        data-test-id={dataTestId}
      >
        {text}
      </OLButton>
    </Link>
  );
};
